import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const BillingPage = lazy(() => import("@/features/dashboard/pages/billing"));

export const Route = createFileRoute("/(app)/dashboard/organisation/billing")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <BillingPage />
    </Suspense>
  ),
});
